package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.component

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.checked_ingredients_list.CheckedIngredient
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent

@Composable
fun AddingCustomAllergeneDialog(
    windowSizeMode: WindowSizeModeEnum,
    ingredients: List<Ingredients>?,
    checkedIngredients: List<CheckedIngredient?>?,
    showCustomAllergenDialogStatus: (Boolean) -> Unit,
    setCreateAllergenComponentStatus: (Boolean) -> Unit,
    onCancelClick: () -> Unit,
    updateAllergenData: (Boolean,String) -> Unit,
)
{
    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onCancelClick()
            }
    ){
        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .backgroundColor(Theme.White.rgb)
                .zIndex(1)
                .boxShadow(
                    color = Theme.ActionDisabledBackground.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r= Dimen.semiLargeRadius),
            horizontalAlignment = Alignment.Start
        ){

            DialogTitle(
                title = Strings.current().addNewAlergene,
                showCloseIcon = true,
                onCloseClick = {
                    onCancelClick()
                },
                showSeparator = false
            )

            Box(
                Modifier.padding(Dimen.extraLargePadding)
            )
            {
                AddingCustomAllergene(
                    modifier = Modifier,
                    windowSizeMode=windowSizeMode,
                    ingredients = ingredients,
                    checkedIngredients=checkedIngredients,
                    showCustomAllergeneDialog={
                        showCustomAllergenDialogStatus(true)
                    },
                    onCancelClick={
                        setCreateAllergenComponentStatus(false)
                    },
                    updateAllergenData = { content, ingredientId ->
                        updateAllergenData(
                            content,ingredientId
                        )
                    }
                )
            }


        }
    }
}